module.exports = __webpack_public_path__ + "static/media/customer.d7122dc2.svg";